export const IMPERSONATED_EMAIL_KEY: string = 'impersonatedEmail';
export const AFTER_INCORRECT_IMPERSONATE_EMAIL_FLAG: string = 'afterIncorrectImpersonateEmail';
